import apiSlice from "../api/apiSlice";

const taskApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getTasks: build.query({
      query: () => "/tasks",
    }),
    getSingleTask: build.query({
      query: (id) => `/tasks/${id}`,
    }),
    addTask: build.mutation({
      query: (body) => ({
        url: "/tasks",
        method: "POST",
        body,
      }),

      async onQueryStarted(body, { queryFulfilled, dispatch }) {
        let postRequest;
        try {
          const result = await queryFulfilled;
          postRequest = dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              draft.push({ ...body, id: result.data.id });
            })
          );
        } catch (error) {
          postRequest.undo();
        }
      },
    }),
    deleteTask: build.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const deletereq = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            const taskIndex = draft.findIndex((task) => task.id == id);
            if (taskIndex !== -1) {
              draft.splice(taskIndex, 1);
            }
          })
        );

        try {
          await queryFulfilled;
        } catch (error) {
          deletereq.undo();
        }
      },
    }),
    updateTask: build.mutation({
      query: (updatedTask) => ({
        url: `/tasks/${updatedTask.id}`,
        method: "PATCH",
        body: updatedTask,
      }),
      async onQueryStarted(updatedTask, { queryFulfilled, dispatch }) {
        let patchrequest;

        try {
          await queryFulfilled;
          patchrequest = dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              const taskIndex = draft.findIndex(
                (task) => task.id == updatedTask.id
              );
              if (taskIndex !== -1) {
                draft[taskIndex] = updatedTask;
              }
            })
          );
        } catch (error) {
          patchrequest.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTasksQuery,
  useGetSingleTaskQuery,
  useAddTaskMutation,
  useDeleteTaskMutation,
  useUpdateTaskMutation,
} = taskApi;
